import { sendTelegramMessage } from "../api/sendTelegramMessage";

export const handleInvite = async (chatId, userName) => {
    const referralLink = `https://t.me/BlueMoonMiniApp_bot?start=r_${chatId}`;
    const message = `Invite your friends and get bonuses for each invited friend!🎁\n\nYour referral link: \`${referralLink}\``;
    const forwardMessage = `🏆+1.5k BlueMoon Coins as a first-time bonus\n💎+30k BlueMoon Coins if you have Telegram Premium`;
    const telegramShareUrl = `https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent(forwardMessage)}`;
    // const appUrl = `https://bluemoon-mini-app.vercel.app?userId=${chatId}&userName=${encodeURIComponent(userName)}`;
    const appUrl = `https://blue-moon-mini-app.vercel.app`;
    const inlineKeyboard = [
        [
            { text: "Invite a friend", url: telegramShareUrl }],
        [
            { text: "Back to BlueMoon", web_app: { url: appUrl } }
        ],
    ];
    await sendTelegramMessage(chatId, message, inlineKeyboard);
}